<template>
  <div class="shop_index">
   	<topbar></topbar>
		<div class="clear"></div>
		<!--店铺banner 开始-->
		<div class="hq-shop-banner"><img v-bind:src="bannerItem.mediaCode" width="1400" height="120"></div>
		<!--店铺banner 结束-->
		<!--店铺导航 开始-->
		<div class="hq-shop-header">
			<div class="w1200 bc bd">
				<ul class="hq-shop-nav">
					<li class="hover">
						<a href="#">Home</a>
					</li>
					<li class="all-goods pr" v-on:mouseenter="goodsCateShow()" v-on:mouseleave="goodsCateHidden()">
						<router-link :to="{path:'/shop_goods_list'}">All products<i class="dp-ico-a-1"></i></router-link>
						<ol class="categorys-dropdown none">
							<li v-for="(carBo, index) in catList" v-if="index<6">
								<router-link :to="{path:'/shop_goods_list',query:{catCode:catBo.catCode,shopCode:shopCode}}">{{catBo.catNameCn}}</router-link>
							</li>
						</ol>
					</li>
					<!--<li>
						<a href="#">企业介绍</a>
					</li>
					<li>
						<a href="#">店铺留言</a>
					</li>
					<li>
						<a href="#">店铺评价</a>
					</li>-->
				</ul>
				<!--<div class="hq-shop-zx fr">
					<a class="a-btn-zx" href="javascript:void(0);">咨询／收藏<i class="dp-ico-a-1"></i></a>
					<div class="zx-drop-box">
						<div class="item-1">
							<i class="dp-ico-arrw"></i>
							<p>店铺等级：<span class="dp-ico-dpdj"></span><span class="dp-ico-dpdj"></span><span class="dp-ico-dpdj"></span></p>
							<p>信用等级： v6 <span class="dp-ico-xydj"></span></p>
						</div>
						<div class="item-2">
							<a class="a-btn-zxzx" href="#"><i class="dp-ico-zxzx"></i>在线咨询</a>
							<a class="a-btn-scbd ml10" href="#"><i class="dp-ico-scbd"></i>收藏本店</a>
						</div>
					</div>
				</div>-->
			</div>
		</div>
		<!--店铺导航 结束-->
		
<div class="w1200 bc">
	<!--筛选 开始-->
    <div class="hq-dp-selector mt20">
    	<div class="hd">
        	<dl>
            	<dt>Selected condition：</dt>
                <dd id="choosedCond">
	                	<span class="checked-item" v-bind:condType="condItem.condType" style="margin-top: 5px;" v-for="(condItem,index) in choosedCondItem">{{condItem.condName}}<a v-on:click="removeCondition(index)" class="del"></a></span>
	              </dd>
            </dl>
        </div>
        <div class="bd">
        	<dl>
            	<dt>price：</dt>
                <dd>
                		 <a v-on:click="chooseCondition($event,'amount','intervalAll')">Unlimited</a>
                 		 <a v-on:click="chooseCondition($event,'amount','0,10000')">Under 10,000+</a>
                     <a v-on:click="chooseCondition($event,'amount','10000,20000')">1-2 million</a>
                     <a v-on:click="chooseCondition($event,'amount','20000,30000')">2-3 million</a>
                     <a v-on:click="chooseCondition($event,'amount','30000,50000')">3-500</a>
                     <a v-on:click="chooseCondition($event,'amount','50000,100000')">5-10 million</a>
                     <a v-on:click="chooseCondition($event,'amount','100000,200000')">10-200,000</a>
                     <a v-on:click="chooseCondition($event,'amount','200000,500000')">20-50 million</a>
                     <a v-on:click="chooseCondition($event,'amount','500000,1000000')">50-100 million</a>
                     <a v-on:click="chooseCondition($event,'amount','1000000')">More than 1 million</a>
                </dd>
            </dl>
        	<dl>
            	<dt>classification：</dt>
                <dd>
                	<a v-on:click="chooseCondition($event,'cat','categoryAll')">Unlimited</a>
                	<a v-for="shopCat in shopCatList" v-on:click="chooseCondition($event,'cat','shopCat.catCode')">{{shopCat.catNameCn}}</a>
                </dd>
            </dl>
        	<dl class="b-n">
            	<dt>release time：</dt>
                <dd>
                		 <a v-on:click="chooseCondition($event,'time','timeAll')">Unlimited</a>
                 		 <a v-on:click="chooseCondition($event,'time','oneDay')">One day</a>
                     <a v-on:click="chooseCondition($event,'time','twoDay')">Two days</a>
                     <a v-on:click="chooseCondition($event,'time','oneWeek')"> Within a week</a>
                     <a v-on:click="chooseCondition($event,'time','oneMonth')"> Within a month</a>
                </dd>
            </dl>
        </div>
    </div>
    <!--筛选 结束-->
   <!--音像专区 开始-->
   <div class="shop-tabbox-1 shop-jp-tj">
      <div class="hd hd-2">
          <div class="pro-tool-2 fr">
            <ul>
                <li v-bind:class='{"hover":sortCondition === "defaultSort"}' v-on:click="sortGoods('defaultSort')">Default</li>
                 <li v-bind:class='{"hover":sortCondition === "saleAmount"}' v-on:click="sortGoods('saleAmount')">Sales <i v-bind:class='{" Up": sortSaleAmount=="asc"}'></i></li>
                 <li v-bind:class='{"hover":sortCondition === "publishTime"}' v-on:click="sortGoods('publishTime')">Publish time <i v-bind:class='{ "up": sortPublishTime=="asc"}'></i></li>
                 <li v-bind:class='{"hover":sortCondition === "price"}' v-on:click="sortGoods('price')">price <i v-bind:class='{" Up": sortPrice=="asc"}'></i></li>
            </ul>
          </div>
          <ul>
              <li class="hover"><a href="javascript:void(0);">all products</a></li>
          </ul>
      </div>
      <div class="bd">
      	  <ul>
              <li v-for="good in shopGoodsItems" v-on:click="toGoodsDetail(good.goodsCode)">
                  <p class="pic tc">
                      <a><img v-bind:src="good.imgMiddle" width="265" height="265"></a>
                  </p>
                  <p class="title">
                      <a>{{good.goodsNameEn}}</a>
                  </p>
                  <p class="other">
                      <span class="price">¥{{good.unitPrice}}</span>
                  </p>
              </li>
          </ul>
          <div class="dp-pages tc">
                <a @click="prePage()"> < </a>
                <a v-bind:class='{"current_page":currentPage === page}' v-for="page in pageList" @click="queryByPage(page)">{{page}}</a>
                <a @click="nextPage()"> > </a>
          </div>
          </div>
  </div>
  
  <!--音像专区 结束-->
	<div class="clear"></div>
    <div class="mb20 ad-4 mt20"><img src="../../../static/images/footer-ad-1.png" width="1200" height="60"></div>
</div>
<!--container 结束-->

	<footermenu></footermenu>
	<footercopyright></footercopyright>

  </div>
</template>

<script>
import TopBar from '@/components/TopBar'
import EmallHeader from '@/components/EmallHeader'
import FooterMenu from '@/components/FooterMenu'
import FooterCopyright from '@/components/FooterCopyright'
import ShopNav from '@/components/ShopNav'
import ShopSlider from '@/components/ShopSlider'
import FooterSlogan from '@/components/FooterSlogan'
import {getImgUrl,getAjaxUrl} from "../../../static/js/emallUtils.js"
//import jQuery from "../../../static/js/jquery.min.js"
import jQuery from 'jquery';
import Vue from 'vue'
import VueRouter from 'vue-router'
	Vue.use(VueRouter)
export default {
  name: 'shop_goods_list',
  data () {
    return {
    	shopGoodsItems:[],
      bannerItem:{},
      shopCatList:'',
      sortCondition:'defaultSort',
      sortSaleAmount:'',
      sortPublishTime:'',
      sortPrice:'',
      choosedCondItem:[],
     	catCode:'categoryAll',
     	interval:'intervalAll',
     	sortTime:'timeAll',
     	currentPage:1,
     	totalPage:1,
     	orderBy:'',
     	orderAsc:'',
     	shopCode:'',
     	pageList:[]
    }
  },
  components:{
				'topbar':TopBar,
				'emallheader':EmallHeader,
				'footermenu':FooterMenu,
				'footercopyright':FooterCopyright,
				'shopnav':ShopNav,
				'shopslider':ShopSlider,
				'footerslogan':FooterSlogan
				
  },
  methods:{
  	toGoodsDetail:function(goodsCode){
				this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
  	},
  	prePage:function(){
  		if(this.currentPage > 1){
  			 this.currentPage = this.currentPage -1;
  			 this.getShopGoods();
  		}
  	},
  	nextPage:function(){
  		if(this.currentPage < this.totalPage){
  			this.currentPage = this.currentPage +1;
  			this.getShopGoods();
  		}
  	},
  	queryByPage:function(page){
  			this.currentPage = page;
  			this.getShopGoods();
  	},
  	chooseCondition:function(event,type,sortParams){
  		var condText = event.target.innerText;
  		var choosedCondText = this.$refs.choosed_cond.innerText;
  		
  		var condText = event.target.innerText;
			    if(condText != "不限"){
	  				var condText = event.target.innerText;
				    if(jQuery("#choosedCond").find("span[condType='"+type+"']").length != 0){
	  					jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
				    }
				    this.choosedCondItem.push({condName:condText,condType:type});
		  		}else{
		  			jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
		  		}
		  		if(type == 'amount'){
	  				this.interval = sortParams;
		  		}else if(type == 'cat'){
		  			  this.catCode = sortParams;
		  		}else if(type == 'time'){
		  			  this.sortTime = sortParams;
		  		}
  				this.getShopGoods();
  	},
  	removeCondition:function(index){
  			this.choosedCondItem.splice(index,1);
  	},
  	sortGoods:function(sortCondition){
  		 this.sortCondition = sortCondition;
  		 if(sortCondition == "saleAmount"){
  		 			this.orderBy = "sale_number";
  		 		  if(this.sortSaleAmount == ''){
    					this.sortSaleAmount = "desc";
	    			}else if(this.sortSaleAmount == 'desc'){
	    				this.sortSaleAmount = "asc";
	    			}else if(this.sortSaleAmount == 'asc'){
	    				this.sortSaleAmount = "desc";
	    			}
	    			this.orderAsc = this.sortSaleAmount;
  		 }
  		 if(sortCondition == "publishTime"){
  		 			this.orderBy = "gmt_create";
  		 		  if(this.sortPublishTime == ''){
    					this.sortPublishTime = "desc";
	    			}else if(this.sortPublishTime == 'desc'){
	    				this.sortPublishTime = "asc";
	    			}else if(this.sortPublishTime == 'asc'){
	    				this.sortPublishTime = "desc";
	    			}
	    			this.orderAsc = this.sortPublishTime;
  		 }
  		 if(sortCondition == "price"){
  		 			this.orderBy = "unit_price";
  		 		  if(this.sortPrice == ''){
    					this.sortPrice = "desc";
	    			}else if(this.sortPrice == 'desc'){
	    				this.sortPrice = "asc";
	    			}else if(this.sortPrice == 'asc'){
	    				this.sortPrice = "desc";
	    			}
	    			this.orderAsc = this.sortPrice;
  		 }
  		 if(sortCondition == "defaultSort"){
  		 		 this.orderBy = "";
  		 		 this.orderAsc = "";
  		 }
  		 this.getShopGoods();
  	},
  	goodsCateShow:function(){
				$(".categorys-dropdown").show();
		},
		goodsCateHidden:function(){
				$(".categorys-dropdown").hide();
		},
  	getShopInfo:function(){
  			var that = this;
  			var shopCode = that.shopCode;
  			this.$http.jsonp(getAjaxUrl()+"/shop/ajax_shop.json",
		      {
		        params: {
		            shopCode:shopCode
		        },
					  jsonp:'callback'
		      }).then(function(res){
		         if(res.body.code == "success"){
		         		 var adsList = res.body.data.adsList;
		         		 
		         		 if(adsList != undefined){
		         		 		var sliderItems = new Array();
		         		 		for(var i=0;i<adsList.length;i++){
		         		 			 adsList[i].mediaCode = getImgUrl() + "/upload/show.htm?filePath=" + adsList[i].mediaCode;
		         		 			 if(adsList[i].adsType == "slider"){
		         		 			 		sliderItems.push(adsList[i]);
		         		 			 }else if(adsList[i].adsType == "banner"){
		         		 			 	  that.bannerItem = adsList[i];
		         		 			 }else if(adsList[i].adsType == "inner_ads"){
		         		 			 	  that.adsItem = adsList[i];
		         		 			 }else if(adsList[i].adsType == "bottom_slogen"){
		         		 			 	  that.bottomAdsItem = adsList[i];
		         		 			 }
		         		 		}
		         		 		that.sliderItems = sliderItems;
		         		 }
		         }
		      },function(){
		        
		      });
  	},
  	getShopGoods:function(){
  						var that = this;
  						var interval = that.interval;
  						var catCode = that.catCode;
  						var cabinetId = "";
  						var pageSize = 8;
  						var currentPage = that.currentPage;
  						var orderBy = that.orderBy;
  						var orderAsc = that.orderAsc;
  				    var shopCode = that.shopCode;
  				    var sortTime = that.sortTime;
				      this.$http.jsonp(getAjaxUrl()+"/goods/ajax_goods_list.json",
				      {
				        params: {
				            cabinetId:cabinetId,
				            catCode:catCode,
				            interval:interval,
				            currentPage:currentPage,
				            orderBy:orderBy,
				            orderAsc:orderAsc,
				            shopCode:shopCode,
				            sortTime:sortTime,
				            pageSize:pageSize
				        },
        					jsonp:'callback'
				      }).then(function(res){
				         if(res.body.code == "success"){
				         	 var goods = res.body.data.goods;
				         	 var totalPage = res.body.data.totalPage;
				         	 that.totalPage = totalPage;
				         	 var pageList = new Array();
				         	 for(var i=1;i<=totalPage;i++){
				         	 		pageList.push(i);
				         	 }
				         	 that.pageList = pageList;
				         	 for(var i=0;i<goods.length;i++){
				         	 	  //商品图片
											var imgMiddle = goods[i].imgMiddle;// 图片
	                    if(imgMiddle.indexOf(";")!=-1){
	                    	imgMiddle=imgMiddle.split(";")[0];
	                    }
	                    imgMiddle = getImgUrl()+"/upload/show.htm?filePath="+imgMiddle;
	                    goods[i].imgMiddle = imgMiddle;
	                    goods[i].unitPrice = goods[i].unitPrice/100;
				         	 }
				         	 that.shopGoodsItems = goods;
				         }else{
				         	
				         }
				      },function(){
				        
				      });
					
  			},
  			getShopCat:function(){
  						var that = this;
  						var shopCode = that.shopCode;
  						var isShow = "y";
  						var isLeaf = "y";
				      this.$http.jsonp(getAjaxUrl()+"/shop/ajax_shop_cat.json",
				      {
				        params: {
				            shopCode:shopCode,
				            isShow:isShow,
				            isLeaf:isLeaf
				        },
        					jsonp:'callback'
				      }).then(function(res){
				         if(res.body.code == "success"){
				         	   var shopCatList = res.body.data.shopCatList;
				         	   that.shopCatList = shopCatList;
				         }else{
				         	
				         }
				      },function(){
				        
				      });
					
  			}
  },
	mounted(){
		 window.scrollTo(0, 0);
		var catCode = this.$route.query.catCode;
		var shopCode =  this.$route.query.shopCode;
		if(catCode != undefined){
				this.catCode = catCode;
		}
		if(shopCode != undefined){
				this.shopCode = shopCode;
		}
	  this.getShopInfo();
	  this.getShopGoods();
	  this.getShopCat();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.current_page{
	border: solid 1px #ea524e;
}
</style>



// WEBPACK FOOTER //
// src/page/shop/shop_goods_list.vue